import React from "react";
import { Route, Routes } from "react-router-dom";
import LoginPage from "../pages/public/login";
import ThemePage from "../pages/public/theme";
import { LOGIN_ROUTE, THEME_ROUTE } from "./types";

function PublicRoutes() {
  return (
    <Routes>
      <Route path={LOGIN_ROUTE} element={<LoginPage />} />
      <Route path={THEME_ROUTE} element={<ThemePage />} />
    </Routes>
  );
}

export default PublicRoutes;
